module.exports = __webpack_public_path__ + "img/newCand-empty-pic.3d3f1f8f.svg";